import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const UPGRADE_WA = `https://wa.me/919322225926?text=${encodeURIComponent("Hi CrewingConnect, my free month has ended. I'd like to upgrade my company plan.")}`;

let cached = null;

// Admin-controlled: true = show launch prices with strikethrough.
export function useStrikePrices() {
  const [strike, setStrike] = useState(true);
  useEffect(() => {
    if (!cached) cached = api.get("/config").then((r) => r.data?.strike_prices !== false).catch(() => true);
    cached.then(setStrike);
  }, []);
  return strike;
}

export const strikeCls = (on, size = "decoration-[3px]") => (on ? `line-through decoration-[#FF3B30] ${size}` : "");
